<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('my sales')"
      :columns="columns"
      :column_search="true"
      resource_url="/central-dispatch-tracker/my-sale/datatables"
    >
      <template v-slot:buttons> </template>
    </generic-table>
  </div>

  <service-modal ref="service_modal" @success="refresh" />
  <send-email-modal ref="send_email_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  get,
  error_message,
  success_message,
  download,
  format_currency,
} from "@/utils";
import ServiceModal from "./service_modal/Index.vue";
import SendEmailModal from "./send_email_modal/Index.vue";
import moment from "moment";

export default {
  name: "DictamensDatatable",
  components: {
    GenericTable,
    ServiceModal,
    SendEmailModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        // {
        //   title: v.$t("select"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<div class="field">
        //               <input
        //                 class="is-checkradio service-checkbox"
        //                 id="chk_${row.uuid}"
        //                 type="checkbox"
        //                 onchange="change_selected({'central_dispatch_id': '${row.central_dispatch_id}','shipper_name': '${row.summary.shipper.name}', 'email': '${row.summary.shipper.email}'})"
        //               />
        //               <label for="chk_${row.uuid}"></label>
        //             </div>`;
        //   },
        // },
        // {
        //   title: v.$t("origin"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<div class="title is-6">${
        //       row.central_dispatch.central_dispatch_data.origin.city || ""
        //     } - ${
        //       row.central_dispatch.central_dispatch_data.origin.state || ""
        //     }</div>
        //     <div class="subtitle is-6">${
        //       row.central_dispatch.central_dispatch_data.origin.metro_area || ""
        //     } (${
        //       row.central_dispatch.central_dispatch_data.origin.zip || ""
        //     })</div>`;
        //   },
        // },
        // {
        //   title: v.$t("destination"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<div class="title is-6">${
        //       row.central_dispatch.central_dispatch_data.destination.city || ""
        //     } - ${
        //       row.central_dispatch.central_dispatch_data.destination.state || ""
        //     }</div>
        //     <div class="subtitle is-6">${
        //       row.central_dispatch.central_dispatch_data.destination
        //         .metro_area || ""
        //     } (${
        //       row.central_dispatch.central_dispatch_data.destination.zip || ""
        //     })</div>`;
        //   },
        // },
        // {
        //   title: v.$t("shipper"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<div class="title is-6">${
        //       row.central_dispatch.central_dispatch_data.shipper.companyName ||
        //       ""
        //     } (${
        //       row.central_dispatch.central_dispatch_data.shipper.rating || ""
        //     })</div>
        //     <div class="subtitle is-6">${
        //       row.central_dispatch.central_dispatch_data.shipper.tierGroup || ""
        //     }</div>`;
        //   },
        // },
        // {
        //   title: v.$t("trip"),
        //   searchable: false,
        //   data: (row) => {
        //     let vehicles =
        //       row.central_dispatch.central_dispatch_data.vehicles.map((v) => {
        //         return `<div class="title is-6">${v.qty} x ${v.year} ${v.make} ${v.model} (${v.vehicleType})</div>`;
        //       });
        //     return `<div class="title is-6">$ ${
        //       row.central_dispatch.central_dispatch_data.price.total
        //     }</div>
        //     <div class="subtitle is-6">${v.$t("distance")} ${
        //       row.central_dispatch.central_dispatch_data.distance
        //     }</div>
        //     <p>${vehicles.join("")}</p>`;
        //   },
        // },
        {
          title: v.$t("data"),
          name: "data",
          searchable: false,
          width: "80%",
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete task?"),
                    v,
                    () => {
                      del("/central-dispatch-tracker/my-tasks", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  v.$refs.service_modal.show(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("save sale"),
                icon: "fa fa-save",
                icon_class: "is-small has-text-primary",
                click: (e) => {
                  v.$refs.service_modal.show(row.uuid);
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
      selected_rows: [],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    update_online() {
      let v = this;
      v.$refs.update_modal.show();
    },
    select_all() {
      let v = this;
      let checkboxes = window.jQuery(".dt-container .service-checkbox");
      checkboxes.map((i, checkbox) => {
        let is_selected = window.jQuery(checkbox).is(":checked");
        if (!is_selected) window.jQuery(checkbox).click();
      });
    },
    deselect_all() {
      let v = this;
      let checkboxes = window.jQuery(".dt-container .service-checkbox");
      checkboxes.map((i, checkbox) => {
        let is_selected = window.jQuery(checkbox).is(":checked");
        if (is_selected) window.jQuery(checkbox).click();
      });
    },
    send_email() {
      let v = this;
      v.$refs.send_email_modal.show(v.selected_rows);
    },
    remove_selected() {
      let v = this;
      let central_dispatch_ids = v.selected_rows.map(
        (x) => x.central_dispatch_id
      );
      confirm_deletion_dialog(
        v.$t("are you sure to delete selected services?"),
        v,
        () => {
          post("/central-dispatch-tracker/service/delete-bulk", {
            central_dispatch_ids: central_dispatch_ids,
          })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    assign_to_user() {
      let v = this;
      v.$refs.assign_modal.show(v.selected_rows);
    },
  },
  mounted() {
    let v = this;
    v.refresh();

    window.change_selected = (obj) => {
      // console.log(obj);
      let index = v.selected_rows.findIndex(
        (x) => x.central_dispatch_id == obj.central_dispatch_id
      );
      if (index > -1) v.selected_rows.splice(index, 1);
      else v.selected_rows.push(obj);
    };
  },
};
</script>

<style></style>
